import Animation from './animation'

/*
 * This animation adds a breakdown animation using a two-part split when there is
 * a single serie displayed.
 */
class AddBreakdownSplitAnimation extends Animation {

  constructor (options) {
    super(options)
    this.twoPart = true
    this.ripple = true
  }

  match (serie) {
    return !this.seriesChanged &&
           this.chart.previous.layout.breakdown.calculated && // Previously calculated
           !this.chart.layout.breakdown.calculated && // Now we're not calculated
           this.series.size() === 1 // We are showing just a single serie
  }

  animate (serie, entering, selection, merged, exiting) {
    // By definition of this animation, we know there's one exiting node,
    // grab its dimensions
    let dim = this._getDimensions(exiting.selection())

    // Add the nodes
    this._split(entering, dim)

    // Now remove the old bar now that the entering nodes are positioned on top
    exiting.selection().remove()
  }

}

export default AddBreakdownSplitAnimation
